import script from "./pricing.vue?vue&type=script&lang=ts&setup=true"
export * from "./pricing.vue?vue&type=script&lang=ts&setup=true"

import "./pricing.vue?vue&type=style&index=0&id=01f81f7e&lang=scss"

const __exports__ = script;

export default __exports__